export const EMPLOYEE_PROFILE = 'EMPLOYEE_PROFILE';

export default EMPLOYEE_PROFILE;
